import { Accordion } from '@mantine/core'

export const AccordionConfig = Accordion.extend({
  defaultProps: {
    variant: 'contained',
    chevronPosition: 'left',
  },
})
